export const RATES = {
  USD: 1, EUR: 0.92, GBP: 0.79, CAD: 1.36,
  NGN: 1490, GHS: 14.85, KES: 129.5, RON: 4.57,
};

export const FLAGS = {
  GBP: "🇬🇧", USD: "🇺🇸", EUR: "🇪🇺", CAD: "🇨🇦",
  NGN: "🇳🇬", GHS: "🇬🇭", KES: "🇰🇪", RON: "🇷🇴",
};

export const CURRENCY_NAMES = {
  GBP: "Pound", USD: "Dollar", EUR: "Euro", CAD: "Dollar",
  NGN: "Naira", GHS: "Cedi",  KES: "Shilling", RON: "Leu",
};

// Consistent narrative cast — woven through every section
export const CAST = {
  michael: { name: "Michael",  city: "London",    country: "🇬🇧", role: "NHS contractor", emoji: "👨🏾‍💼" },
  mama:    { name: "Mama",     city: "Lagos",     country: "🇳🇬", role: "Mother",         emoji: "👩🏾"   },
  amara:   { name: "Amara",    city: "Toronto",   country: "🇨🇦", role: "Tech lead",      emoji: "👩🏾‍💻" },
  david:   { name: "David",    city: "Bucharest", country: "🇷🇴", role: "Student",        emoji: "👨🏻‍🎓" },
  fatima:  { name: "Fatima",   city: "London",    country: "🇬🇧", role: "Entrepreneur",   emoji: "👩🏽‍💼" },
};

export const TICKER_ITEMS = [
  "Michael A. — London → Lagos  £500  ✓ arrived in 1m 21s",
  "Amara K. — Toronto → Accra  $640  ✓ arrived in 2m 08s",
  "Chioma E. — New York → Lagos  $1,200  ✓ arrived in 1m 56s",
  "Grace N. — Berlin → Nairobi  €450  ✓ arrived in 2m 15s",
  "David C. — Bucharest → Lagos  €200  ✓ arrived in 1m 38s",
  "Fatima K. — London → Freetown  £380  ✓ arrived in 2m 04s",
  "Samuel D. — Toronto → Lagos  $900  ✓ arrived in 1m 51s",
  "Kwame A. — Toronto → Accra  $550  ✓ arrived in 2m 22s",
];

export const LIVE_FEED = [
  { id: "lf1", name: "Michael A.", from: "GBP", to: "NGN", amount: "£500",   dest: "Lagos",     color: "var(--color-success)" },
  { id: "lf2", name: "Amara K.",   from: "CAD", to: "GHS", amount: "CA$640", dest: "Accra",     color: "#06B6D4" },
  { id: "lf3", name: "Chioma E.",  from: "USD", to: "NGN", amount: "$1,200", dest: "Lagos",     color: "var(--color-success)" },
  { id: "lf4", name: "Grace N.",   from: "EUR", to: "KES", amount: "€450",   dest: "Nairobi",   color: "#6366F1" },
  { id: "lf5", name: "David C.",   from: "EUR", to: "NGN", amount: "€200",   dest: "Lagos",     color: "#7C3AED" },
  { id: "lf6", name: "Fatima K.",  from: "GBP", to: "NGN", amount: "£380",   dest: "Freetown",  color: "var(--color-warning)" },
  { id: "lf7", name: "Samuel D.",  from: "CAD", to: "NGN", amount: "CA$900", dest: "Lagos",     color: "var(--color-success)" },
  { id: "lf8", name: "Kwame A.",   from: "CAD", to: "GHS", amount: "CA$550", dest: "Accra",     color: "#06B6D4" },
];

export const FEATURES = [
  {
    n: "01", tag: "Multi-currency wallets",
    title: "Seven currencies.\nOne home.",
    body: "Hold GBP, USD, EUR, CAD, NGN, GHS, KES, and RON simultaneously. Each wallet has its own local account number and payment rails. Switch between them instantly — no conversion until you choose.",
    stat: "7", unit: "currencies", color: "var(--color-success)", dark: false,
    bullets: [
      "Dedicated IBANs and local account details",
      "Instant inter-wallet conversion",
      "Real-time balance across all currencies",
    ],
  },
  {
    n: "02", tag: "Transparent pricing",
    title: "The real\nexchange rate.",
    body: "Banks mark up the exchange rate by 3–5% and call it free. We don't. You get the mid-market rate — the one you see on Google — plus a 0.5% flat fee. Nothing else, ever.",
    stat: "0.5%", unit: "flat fee", color: "#06B6D4", dark: true,
    bullets: [
      "Mid-market exchange rate, always",
      "Full fee breakdown before you confirm",
      "Up to 8× cheaper than your bank",
    ],
  },
  {
    n: "03", tag: "Speed & reliability",
    title: "Delivered within\na day, tracked live.",
    body: "We built on modern payment rails, with every transfer moving through real compliance checks before it reaches your recipient — not the 1970s SWIFT network, and never a status we can't stand behind. You'll see exactly where your money is, every step of the way.",
    stat: "24h", unit: "typical delivery", color: "#7C3AED", dark: false,
    bullets: [
      "Real-time tracking from send to arrival",
      "Every step confirmed before we say it happened",
      "Instant SMS + push notification on arrival",
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Adaeze Okonkwo", role: "NHS Nurse", city: "London",
    photo: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=96&h=96&q=80&auto=format&fit=crop&crop=face",
    quote: "I've been sending money home for 8 years. MoneyMeet is the first platform that actually feels built for me — not just a utility, but something I'm proud to use.",
    initials: "AO", color: "var(--color-success)", corridor: "London → Lagos", stars: 5,
  },
  {
    name: "Kwame Asante", role: "Software Engineer", city: "Toronto",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=96&h=96&q=80&auto=format&fit=crop&crop=face",
    quote: "I compared seven remittance apps. The rates were best here. But I stayed because of how the product feels. It respects my time. It treats me like an adult.",
    initials: "KA", color: "#06B6D4", corridor: "Toronto → Accra", stars: 5,
  },
  {
    name: "Fatima Al-Hassan", role: "Business Owner", city: "Berlin",
    photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=96&h=96&q=80&auto=format&fit=crop&crop=face",
    quote: "We pay 12 contractors across five African countries through MoneyMeet. Treasury view is clean, rates are fair, money arrives when they say it will. Zero surprises.",
    initials: "FH", color: "#7C3AED", corridor: "Berlin → Multiple", stars: 5,
  },
  {
    name: "Emmanuel Diallo", role: "Graduate Student", city: "Paris",
    photo: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=96&h=96&q=80&auto=format&fit=crop&crop=face",
    quote: "Before MoneyMeet I was losing €40 every time I sent money home. Now I lose €2. The difference over a year is extraordinary. This product changed my relationship with money.",
    initials: "ED", color: "var(--color-warning)", corridor: "Paris → Dakar", stars: 5,
  },
];

export const FAQS = [
  { q: "How much does MoneyMeet Pay cost?",    a: "[REQUIRED: confirm and state our actual fee structure before this answer is published — no fee-calculation logic matching a flat 0.5% figure exists in the current implementation.]" },
  { q: "How fast does money arrive?",          a: "Typically within 24 hours once your payment is confirmed. Every transfer passes through security checks first — we always show your real, current status before and after you send, never an optimistic guess." },
  { q: "Which countries can I send to?",       a: "We're focused on Africa first: Nigeria, Ghana, and Kenya today, by bank transfer or mobile money, with more corridors on the way. Check the send money screen for the current list — we only ever show a destination as available once it genuinely is." },
  { q: "Is MoneyMeet Pay regulated?",          a: "MoneyMeet operates full identity verification (KYC), anti-money-laundering (AML), and sanctions screening on every account and transaction. [REQUIRED: confirm and state our specific licensing/regulatory status before this answer is published — do not claim Electronic Money Institution status unless independently confirmed.]" },
  { q: "What do I need to verify my account?", a: "Just a passport or national ID and a selfie. Most verifications complete in under 2 minutes. Occasionally up to 24 hours for manual review." },
  { q: "Can businesses use MoneyMeet Pay?",    a: "Yes — business accounts include batch payments, API access, multi-user management, treasury dashboards, and preferential FX rates for high-volume transfers." },
];

// Only real, currently-modeled corridors (a funding market this app
// actually collects from, paired with an African destination the payout
// side is actually built for — see backend/corridors.py). Whether any one
// of these is genuinely LIVE right now is decided by real provider
// capability, never by this list — the in-app Send Money screen is the
// source of truth for that; this is illustrative only. "time" reflects
// the platform's real, honest delivery estimate, not an aspirational one.
export const CORRIDORS = [
  { from: "🇬🇧", to: "🇳🇬", label: "London → Lagos",   rate: "1 GBP = 1,489 NGN", time: "Typically 24h", color: "var(--color-success)" },
  { from: "🇺🇸", to: "🇬🇭", label: "New York → Accra", rate: "1 USD = 14.85 GHS",  time: "Typically 24h", color: "#06B6D4" },
  { from: "🇨🇦", to: "🇳🇬", label: "Toronto → Lagos",  rate: "1 CAD = 1,095 NGN",  time: "Typically 24h", color: "var(--color-warning)" },
  { from: "🇩🇪", to: "🇰🇪", label: "Berlin → Nairobi", rate: "1 EUR = 140.8 KES",  time: "Typically 24h", color: "#6366F1" },
];
